(() => {
  const opening=document.querySelector('.opening'),stage=document.querySelector('.stage');
  const passport=document.querySelector('.passport'),photo=document.querySelector('.passport-photo');
  const picker=document.querySelector('.stone-picker');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const gs=window.gsap;
  let timeline=null,frame=0,last=0,chapter=-1;
  const clamp=(v)=>Math.max(0,Math.min(1,v));
  function setup(){
    timeline?.kill();
    document.body.classList.toggle('motion',!!gs&&!reduced.matches);
    const animated=!!gs&&!reduced.matches;
    picker.inert=animated;
    document.querySelector('.opening-bottom').inert=animated;
    for(const el of [passport,photo,...document.querySelectorAll('.opening-type,.opening-bottom,.pass-note,.stone-picker,.original-word,.photo-caption,.photo-shade,.scene-count')])el.style.cssText='';
    if(!animated){timeline=null;return;}
    const mobile=innerWidth<=700;
    const cardHeight=Math.min(mobile?425:610,innerHeight*(mobile?.55:.70));
    const cardWidth=Math.min(mobile?innerWidth-80:390,cardHeight*.67);
    timeline=gs.timeline({paused:true});
    timeline.to('.opening-type',{y:-80,opacity:0,duration:.3,ease:'power2.in'},0)
      .to('.opening-bottom',{opacity:0,duration:.2},.03)
      .to(passport,{width:cardWidth,height:cardHeight,top:mobile?'49%':'46%',boxShadow:'0 24px 60px rgba(0,0,0,.14)',duration:.58,ease:'power2.inOut'},.12)
      .to(photo,{height:'53%',duration:.38,ease:'power2.inOut'},.43)
      .to('.photo-shade',{opacity:0,duration:.3},.45)
      .to('.original-word',{opacity:1,duration:.3},.5)
      .to('.photo-caption',{opacity:1,duration:.2},.66)
      .to('.pass-note',{opacity:1,y:0,duration:.25},.68)
      .to(picker,{opacity:1,duration:.2},.8)
      .to('.scene-count',{opacity:1,duration:.2},.8);
    update(true);
  }
  function update(immediate=false){
    frame=0;
    const target=clamp(-opening.getBoundingClientRect().top/Math.max(1,opening.offsetHeight-stage.offsetHeight));
    last=immediate?target:last+(target-last)*.14;
    if(timeline){timeline.progress(last);picker.inert=last<.82;document.querySelector('.opening-bottom').inert=last>.1;document.querySelector('.scene-count i').style.transform=`scaleX(${last})`;if(Math.abs(target-last)>.0005)frame=requestAnimationFrame(()=>update());}
    let nearest=0,distance=Infinity;
    document.querySelectorAll('.chapter').forEach((el,i)=>{const r=el.getBoundingClientRect(),d=Math.abs(r.top+r.height/2-innerHeight/2);if(d<distance){distance=d;nearest=i;}});
    if(nearest!==chapter){chapter=nearest;document.querySelectorAll('.chapter-image').forEach((el,i)=>el.classList.toggle('active',i===chapter));document.querySelector('.visual-index').textContent=`0${chapter+1} / 03`;}
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(()=>update());}
  addEventListener('scroll',schedule,{passive:true});
  let resizeTimer;addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(setup,150);},{passive:true});
  reduced.addEventListener('change',setup);
  const stones=[
    {name:'Nero Portoro',url:'https://roxxlyn.com/cdn/shop/files/Nero-Portoro-roxxlyn.png?v=1789629926&width=2000'},
    {name:'Rosso Levanto',url:'https://roxxlyn.com/cdn/shop/files/rxk-stein-rosso-levanto.jpg?v=1789747137&width=1800'},
    {name:'Invisible Grey',url:'https://roxxlyn.com/cdn/shop/files/rxk-stein-invisible-grey.jpg?v=1789747129&width=1800'}
  ];
  let selection=0;
  document.querySelectorAll('[data-stone]').forEach(button=>button.addEventListener('click',()=>{
    const id=Number(button.dataset.stone),stone=stones[id];selection=id;
    const img=new Image();img.onload=()=>{
      if(selection!==id)return;
      const displayed=document.getElementById('pass-image');displayed.src=stone.url;displayed.alt=stone.name+' Naturstein';
      document.getElementById('pass-stone').textContent=stone.name;document.getElementById('pass-material').textContent=stone.name;
      document.querySelectorAll('[data-stone]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.stone)===id)));
      document.getElementById('stone-status').textContent=stone.name+' ausgewählt.';
      if(gs&&!reduced.matches)gs.fromTo(displayed,{opacity:.25},{opacity:1,duration:.6,overwrite:true});
    };img.onerror=()=>{document.getElementById('stone-status').textContent='Das Bild konnte nicht geladen werden. Bitte erneut versuchen.';};img.src=stone.url;
  }));
  setup();
  if(gs&&!reduced.matches){
    gs.fromTo('.opening-type',{y:35,opacity:0},{y:0,opacity:1,duration:1.2,ease:'power3.out',onComplete:()=>update(true)});
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){gs.fromTo(entry.target,{y:35,opacity:.25},{y:0,opacity:1,duration:1,ease:'power2.out'});observer.unobserve(entry.target);}}),{threshold:.15});
    document.querySelectorAll('.manifesto-grid,.privileges-heading,.wallpaper-title,.more article,.faq>div:first-child').forEach(el=>observer.observe(el));
  }
})();
